// import { IMAGES } from "../lzapps_common_code/assets";

// import { USER_DEAFULT_KEY } from "../lzapps_common_code/constant";

// import AsyncStorage from "@react-native-async-storage/async-storage";

import {
  APP_DOMAIN_LIST as APP_DOMAIN_LIST_HEALTH,
  PRACTICE_TEST as PRACTICE_TEST_HEALTH,
  GET_STUDY_QUESTION_MENU as GET_STUDY_QUESTION_MENU_HEALTH,
  GET_FLASH_CARD_MENU as GET_FLASH_CARD_MENU_HEALTH,
  QUESTION_VERSION_OF_JSON as QUESTION_VERSION_OF_JSON_HEALTH,
} from './health'
import {
  APP_DOMAIN_LIST as APP_DOMAIN_LIST_LIFE,
  PRACTICE_TEST as PRACTICE_TEST_LIFE,
  GET_STUDY_QUESTION_MENU as GET_STUDY_QUESTION_MENU_LIFE,
  GET_FLASH_CARD_MENU as GET_FLASH_CARD_MENU_LIFE,
  QUESTION_VERSION_OF_JSON as QUESTION_VERSION_OF_JSON_LIFE,
} from './life'
import {
  APP_DOMAIN_LIST as APP_DOMAIN_LIST_PROPERTY,
  PRACTICE_TEST as PRACTICE_TEST_PROPERTY,
  GET_STUDY_QUESTION_MENU as GET_STUDY_QUESTION_MENU_PROPERTY,
  GET_FLASH_CARD_MENU as GET_FLASH_CARD_MENU_PROPERTY,
  QUESTION_VERSION_OF_JSON as QUESTION_VERSION_OF_JSON_PROPERTY,
} from './property'

import LOGO_HEALTH from './health/logo_app_title.png'
import LOGO_LIFE from './life/logo_app_title.png'
import LOGO_PROPERTY from './property/logo_app_title.png'

import LOGO_LANDSCAPE_HEALTH from './health/logo_landscape.png'
import LOGO_LANDSCAPE_LIFE from './life/logo_landscape.png'
import LOGO_LANDSCAPE_PROPERTY from './property/logo_landscape.png'

import { IMAGES } from "../lzapp_web_common_code/assets";
import { USER_DEAFULT_KEY } from "../lzapp_web_common_code/constant/event";

export const APP_BUNDLES = [
  {
    title: 'Health Insurance',
    key: 'health',
    bundle_firebase_collection_name: 'Health_Insurance',
    bundle_id: 1,
    THEME_DARK: "#0973ba",
    THEME_LIGHT: "#f79764",
    THEME_BORDER: "#0868a7",
    PREMIUM_BACKGROUND: "#e6f1f8",
    THEME_DARK_MODE: "#1E1F25",
    THEME_LIGHT_DARK_MODE: "#f79764",
    THEME_BORDER_DARK_MODE: "#18191e",
    PREMIUM_BACKGROUND_DARK_MODE: "#1E1F25"
  },
  {
    title: 'Life Insurance',
    key: 'life',
    bundle_firebase_collection_name: 'Life_Insurance',
    bundle_id: 2,
    THEME_DARK: "#0973ba",
    THEME_LIGHT: "#f79764",
    THEME_BORDER: "#0868a7",
    PREMIUM_BACKGROUND: "#e6f1f8",
    THEME_DARK_MODE: "#1E1F25",
    THEME_LIGHT_DARK_MODE: "#f79764",
    THEME_BORDER_DARK_MODE: "#18191e",
    PREMIUM_BACKGROUND_DARK_MODE: "#1E1F25"
  },
  {
    title: 'Property and Casualty',
    key: 'property',
    bundle_firebase_collection_name: 'Property_and_Casualty',
    bundle_id: 3,
    THEME_DARK: "#0973ba",
    THEME_LIGHT: "#f79764",
    THEME_BORDER: "#0868a7",
    PREMIUM_BACKGROUND: "#e6f1f8",
    THEME_DARK_MODE: "#1E1F25",
    THEME_LIGHT_DARK_MODE: "#f79764",
    THEME_BORDER_DARK_MODE: "#18191e",
    PREMIUM_BACKGROUND_DARK_MODE: "#1E1F25"
  },
]

export const APP_DATA = {
  SUBSCRIPTION_PLANS: [1, 3, 6, 12],
  DISPLAY_APP_NAME: 'Insurance Exam Prep',
  APP_ID: '1555533017'
};

export const GET_APP_NAME = (SELECTED_BUNDLE) => {
  if (SELECTED_BUNDLE) {
    if (SELECTED_BUNDLE == 'life') {
      return 'Life Insurance'
    }
    else if (SELECTED_BUNDLE == 'property') {
      return 'Property and Casualty'
    }
    else if (SELECTED_BUNDLE == 'health') {
      return 'Health Insurance'
    }
  }
  else {
    return 'Health Insurance'
  }
};

const APP_NAME = "INSURANCE";

export const BUNDLE_APP_NAME = "INSURANCE";

export const IS_BUNDLE_APP = true;

export const ENABLE_PUSH = false

export const GET_APP_NAME_FOR_COLLECTION = async () => {
  const result = localStorage.getItem(USER_DEAFULT_KEY.SAVED_BUNDLE_DETAILS);
  if (result) {
    if (result == 'life') {
      return 'Life_Insurance'
    }
    else if (result == 'property') {
      return 'Property_and_Casualty'
    }
    else if (result == 'health') {
      return 'Health_Insurance'
    }
  }
  else {
    return 'Health_Insurance'
  }
};
export const GET_APP_NAME_FOR_LOGO = (SELECTED_BUNDLE) => {
  if (SELECTED_BUNDLE) {
    if (SELECTED_BUNDLE == "life") {
      return "<strong>Life Insurance</strong> Exam Prep";
    } else if (SELECTED_BUNDLE == "property") {
      return "<strong>Property & Casualty</strong> Exam Prep";
    } else if (SELECTED_BUNDLE == "health") {
      return "<strong>Health Insurance</strong> Exam Prep";
    }
  } else {
    return "Insurance Exam Prep";
  }
};

export const GET_QUESTION_VERSION_OF_JSON = async () => {
  const result = localStorage.getItem(USER_DEAFULT_KEY.SAVED_BUNDLE_DETAILS);
  if (result) {
    if (result == 'life') {
      return QUESTION_VERSION_OF_JSON_LIFE
    }
    else if (result == 'property') {
      return QUESTION_VERSION_OF_JSON_PROPERTY
    }
    else if (result == 'health') {
      return QUESTION_VERSION_OF_JSON_HEALTH
    }
  }
  else {
    return QUESTION_VERSION_OF_JSON_HEALTH
  }
};

export let THEME_DARK = '#592409'
export let THEME_LIGHT = '#FF610F'
export let THEME_BORDER = '#693921'
export let PREMIUM_BACKGROUND = "#FFEAE0"

export let THEME_DARK_MODE = "#177346";
export let THEME_LIGHT_DARK_MODE = "#1AA260";
export let THEME_BORDER_DARK_MODE = "#693921";
export let PREMIUM_BACKGROUND_DARK_MODE = "#FFEAE0";

/*** STATIC STRINGS ***/
const app_url = "https://www.learnzapp.com/apps/insurance";

export const GET_PRACTICE_TEST = (SELECTED_BUNDLE) => {
  if (SELECTED_BUNDLE) {
    if (SELECTED_BUNDLE == 'life') {
      return PRACTICE_TEST_LIFE
    }
    else if (SELECTED_BUNDLE == 'property') {
      return PRACTICE_TEST_PROPERTY
    }
    else if (SELECTED_BUNDLE == 'health') {
      return PRACTICE_TEST_HEALTH
    }
  }
  else {
    return PRACTICE_TEST_HEALTH
  }
};

export const GET_APP_DOMAIN_LIST = (SELECTED_BUNDLE) => {
  if (SELECTED_BUNDLE) {
    if (SELECTED_BUNDLE == 'life') {
      return APP_DOMAIN_LIST_LIFE
    }
    else if (SELECTED_BUNDLE == 'property') {
      return APP_DOMAIN_LIST_PROPERTY
    }
    else if (SELECTED_BUNDLE == 'health') {
      return APP_DOMAIN_LIST_HEALTH
    }
  }
  else {
    return APP_DOMAIN_LIST_HEALTH
  }
};

export const GET_STUDY_QUESTION_MENU = (SELECTED_BUNDLE) => {
  if (SELECTED_BUNDLE) {
    if (SELECTED_BUNDLE == 'life') {
      return GET_STUDY_QUESTION_MENU_LIFE()
    }
    else if (SELECTED_BUNDLE == 'property') {
      return GET_STUDY_QUESTION_MENU_PROPERTY()
    }
    else if (SELECTED_BUNDLE == 'health') {
      return GET_STUDY_QUESTION_MENU_HEALTH()
    }
  }
  else {
    return GET_STUDY_QUESTION_MENU_HEALTH()
  }
};

export const GET_FLASH_CARD_MENU = (SELECTED_BUNDLE) => {
  if (SELECTED_BUNDLE) {
    if (SELECTED_BUNDLE == 'life') {
      return GET_FLASH_CARD_MENU_LIFE()
    }
    else if (SELECTED_BUNDLE == 'property') {
      return GET_FLASH_CARD_MENU_PROPERTY()
    }
    else if (SELECTED_BUNDLE == 'health') {
      return GET_FLASH_CARD_MENU_HEALTH()
    }
    else {
      return GET_FLASH_CARD_MENU_HEALTH()
    }
  }
};

/** PROFILE MENU */
export const GET_PROFILE_MENU = () => {
  return [
    {
      title: "App Appearance",
      image: IMAGES?.ic_dark_mode,
    },
    {
      title: "Account Setting",
      image: IMAGES?.ic_account,
    },
    {
      title: "Settings",
      image: IMAGES?.ic_subscription,
    },
    {
      title: "Reset App Data",
      image: IMAGES?.ic_reset,
    },
    {
      title: "Share this app",
      image: IMAGES?.ic_share_app,
    },
    {
      title: "Review App",
      image: IMAGES?.ic_review,
    },
    {
      title: "Other Apps",
      image: IMAGES?.ic_other_app,
    },
    {
      title: "Help and Support",
      image: IMAGES?.ic_help,
    },
  ];
};

/*** LEADING SCREEN TUTORIAL ARRAY ***/
export const GET_TUTORIALS = () => {
  return [
    {
      title: `Insurance Exam Prep App`,
            image: IMAGES.slide_1,
            description:
                'Ace your exams on the first try with this comprehensive study app! \n 1300+ practice questions with detailed explanations to prepare for Life Insurance, Property and Casualty, and Health Insurance exams.',
    },
    {
      title: "Readiness Score",
      image: IMAGES.slide_2,
      description:
        "The readiness score in the app provides a quick and easy way for you to assess your level of preparedness for the real exam, and to identify areas where you need to focus your study efforts in order to improve their chances of success.",
    },
    {
      title: "Practice makes Perfect!!",
      image: IMAGES.slide_3,
      description:
        "Create your own custom tests by choosing the topics and the number of questions or take pre-built practice tests and mock exams. \nThe custom test engine creates personalized tests with new and your weakest questions.",
    },
    {
      title: "Track your Progress",
      image: IMAGES.slide_4,
      description:
        "Keep track of your progress through the study materials and see how much you have left to complete. \nView the history of your completed tests and re-take any of them as needed.",
    },
    {
      title: "Available on-the-go",
      image: IMAGES.slide_5,
      description:
        "The app is available on both iOS and Android devices, so you study anywhere, anytime. \nYou can seamlessly access and work with your data across multiple devices.",
    },
  ];
};

export const GET_QUICK_ASSESSMENT = () => {
  return {
    title: "Assessment Test",
    image: IMAGES.quick_assessment,
    description:
      "This assessment test will help us prepare your baseline readiness score.",
  };
};

/** PLAN DETAILS */
export const PREMIUM_PLAN_DETAILS = [
  "Prepare for <strong>Life, Health, and Property & Casualty</strong> Insurance Exams with LearnZapp, in partnership with The Securities Institute of America. Access over 1,300 practice questions, dynamic quizzes, and personalized recommendations. Track your progress, gauge your readiness, and customize your study routine with our state-of-the-art tools. Stay up-to-date with the latest content for all 50 states and ensure your success in the insurance industry. Upgrade now and start your journey to becoming a certified professional!"
];

/** FREE PLANS */
export const FREE_PLAN_DETAILS = [
  "Limited access to a selection of questions and flashcards. Explore the app's features with the free plan before upgrading to premium."
];

/** PLAN PRICING */
export const PLAN_PRICING = [
  {
    off_percentage: "",
    month_price: "$5",
    bill_price: "$5",
    bill_time: "Monthly",
  },
  {
    off_percentage: "10% Off",
    month_price: "$4",
    bill_price: "$24",
    bill_time: "Quarterly",
  },
  {
    off_percentage: "",
    month_price: "$3",
    bill_price: "$36",
    bill_time: "Annually",
  },
];

/** STRINGS */
export const STRING = {
  share_message:
    "Hey there, I am using this app to prepare for PHR and SPHR certification exams. I think you will find it very useful. Check it out " +
    app_url,
};

export const GET_APP_HEADER_LOGO = (SELECTED_BUNDLE) => {
  if (SELECTED_BUNDLE) {
    if (SELECTED_BUNDLE == 'life') {
      return LOGO_LIFE
    }
    else if (SELECTED_BUNDLE == 'property') {
      return LOGO_PROPERTY
    }
    else if (SELECTED_BUNDLE == 'health') {
      return LOGO_HEALTH
    }
  }
  else {
    return LOGO_HEALTH
  }
};

export const GET_APP_LANDSACPE_HEADER_LOGO = (SELECTED_BUNDLE) => {
  if (SELECTED_BUNDLE) {
    if (SELECTED_BUNDLE == 'life') {
      return LOGO_LIFE
    }
    else if (SELECTED_BUNDLE == 'property') {
      return LOGO_PROPERTY
    }
    else if (SELECTED_BUNDLE == 'health') {
      return LOGO_HEALTH
    }
  }
  else {
    return LOGO_HEALTH
  }
};

export const THIRD_PARTY_CONFIG = {
  STRIPE_PRODUCT_ID: process.env.REACT_APP_STRIPE_PRODUCT_ID,
  MIXPANEL_TOKEN: process.env.REACT_APP_MIXPANEL_TOKEN,
};
